const MAIN_FRAMES = {
  CONFIG_EOL_EOS_TARGET: 'Config - EOL/EOS Target',
  CONFIG_EOL_EOS_POLICY: 'Config - EOL/EOS Policy',
  CONFIG_EOL_EOS_POLICY_DETAIL: 'Config - EOL/EOS Policy Detail',
} as const;

export const CONFIG_ASSET_MANAGEMENT_FRAME_NAMES = {
  // EOL/EOS Target
  CONFIG_EOL_EOS_TARGET: {
    TARGET_TYPE_LIST: `${MAIN_FRAMES.CONFIG_EOL_EOS_TARGET}[Get] Target Type List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_EOL_EOS_TARGET}[Get] Target List`,
    TARGET_INDIVIDUAL_LIST: `${MAIN_FRAMES.CONFIG_EOL_EOS_TARGET}[Get] Target Individual List`,
    TARGET_UPDATE: `${MAIN_FRAMES.CONFIG_EOL_EOS_TARGET}[Patch] Target`,
  },

  // EOL/EOS Policy
  CONFIG_EOL_EOS_POLICY: {
    POLICY_TARGET_TYPE_LIST: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY}[Get] Policy > Target Type List`,
    POLICY_LIST: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY}[Get] Policy List`,
    POLICY_INFO: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY}[Get] Policy Info`,
    BEFORE_SAVE_CHECK: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY}[Post] Before Save Check`,
    POLICY_ADD_OR_EDIT: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY}[Patch] Policy Add or Edit`,
    OS_INFO_LIST: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY}[Get] Os Info List`,
    POLICY_DELETE: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY}[Delete] Policy`,
    POLICY_TOGGLE: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY}[Patch] Policy Toggle`,
  },

  // EOL/EOS Policy Detail
  CONFIG_EOL_EOS_POLICY_DETAIL: {
    POLICY_DETAIL_INFO: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY_DETAIL}[Get] Policy Detail Info`,
    POLICY_TARGET_LIST: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY_DETAIL}[Get] Policy Target List`,
    POLICY_HISTORY_LIST: `${MAIN_FRAMES.CONFIG_EOL_EOS_POLICY_DETAIL}[Get] Policy History List`,
  },
} as const;
